"use client";

import { useSupabase } from "@/app/supabase-provider";
import { TraceScope } from "@/components/providers/TraceScope";
import { useSessionWorkspace } from "@/components/providers/org_provider";
import { useUser } from "@/components/providers/user_provider";

// Mount once inside the workspace layout, below SupabaseProvider/OrgProvider/UserProvider.
export function WorkspaceTraceScope() {
  // The server-hydrated user is present on the first commit; the Supabase auth
  // user only arrives after the client auth effect, so it is the fallback.
  const { user } = useUser();
  const { user: authUser } = useSupabase();
  const { org: workspace } = useSessionWorkspace();
  return (
    <TraceScope
      userId={user?.id ?? authUser?.id}
      organizationId={workspace?.id}
    />
  );
}
